interface ModalProps {
    on: boolean;
}


export const Slider = (props: ModalProps) => {
    return (
        <svg width="42" height="39" viewBox="0 0 42 39" fill="none" xmlns="http://www.w3.org/2000/svg" >
            <g id="slider" >
                <g id="Oval" filter="url(#filter0_ddd_2092_1618)" >
                    <path d="M22 31.5C28.6274 31.5 34 26.1274 34 19.5C34 12.8726 28.6274 7.5 22 7.5C15.3726 7.5 10 12.8726 10 19.5C10 26.1274 15.3726 31.5 22 31.5Z" fill={props.on ? "#EB3D00" : '#919191'} />
                    {props.on && <path d="M22 32C28.9036 32 34.5 26.4036 34.5 19.5C34.5 12.5964 28.9036 7 22 7C15.0964 7 9.5 12.5964 9.5 19.5C9.5 26.4036 15.0964 32 22 32Z" stroke="url(#paint0_linear_2092_1618)" strokeOpacity="0.46" />}
                    {props.on && <path d="M22 32C28.9036 32 34.5 26.4036 34.5 19.5C34.5 12.5964 28.9036 7 22 7C15.0964 7 9.5 12.5964 9.5 19.5C9.5 26.4036 15.0964 32 22 32Z" stroke="url(#paint1_linear_2092_1618)" />}
                </g>
                < line id="Line 15" x1="22.5" y1="16" x2="22.5" y2="23" stroke="#FBFDFD" strokeWidth="3" strokeLinecap="round" />
            </g>
            <defs>
                {props.on && <filter id="filter0_ddd_2092_1618" x="0" y="-2.5" width="42" height="42" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB" >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dx="1" dy="1" />
                    <feGaussianBlur stdDeviation="1" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0.921569 0 0 0 0 0.239216 0 0 0 0 0 0 0 0 0.41 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2092_1618" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dx="-1" dy="-1" />
                    <feGaussianBlur stdDeviation="4" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0.921569 0 0 0 0 0.239216 0 0 0 0 0 0 0 0 0.4 0" />
                    <feBlend mode="normal" in2="effect1_dropShadow_2092_1618" result="effect2_dropShadow_2092_1618" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dx="2" dy="2" />
                    <feGaussianBlur stdDeviation="2" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0.921569 0 0 0 0 0.239216 0 0 0 0 0 0 0 0 0.1 0" />
                    <feBlend mode="normal" in2="effect2_dropShadow_2092_1618" result="effect3_dropShadow_2092_1618" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect3_dropShadow_2092_1618" result="shape" />
                </filter>}
                < linearGradient id="paint0_linear_2092_1618" x1="32.8889" y1="30.0882" x2="14.3034" y2="30.86" gradientUnits="userSpaceOnUse" >
                    <stop stopColor="#EB3D00" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                < linearGradient id="paint1_linear_2092_1618" x1="22" y1="7.5" x2="22" y2="31.5" gradientUnits="userSpaceOnUse" >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="white" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg >
    )
}
